import { render, staticRenderFns } from "./product-group-edit.vue?vue&type=template&id=8e90316c&scoped=true&"
import script from "./product-group-edit.vue?vue&type=script&lang=js&"
export * from "./product-group-edit.vue?vue&type=script&lang=js&"
import style0 from "./product-group-edit.vue?vue&type=style&index=0&id=8e90316c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e90316c",
  null
  
)

export default component.exports